import React from 'react'
import { GoalCanvasZone } from '../../../goals/GoalCanvasZone.jsx'

/**
 * GoalsSection — thin wrapper around GoalCanvasZone for the session canvas.
 *
 * Props:
 *   ownerUserId     string
 *   sessionId       string
 *   goalSnapshot    array|null — provided for completed sessions
 *   readOnly        boolean
 *   onNavigateGoals function
 *   onNavigateGoal  function
 */
export function GoalsSection({ ownerUserId, sessionId, goalSnapshot, readOnly, onNavigateGoals, onNavigateGoal }) {
  return (
    <div className="goals-section" data-testid="goals-section">
      <GoalCanvasZone
        ownerUserId={ownerUserId}
        sessionId={sessionId}
        goalSnapshot={goalSnapshot ?? null}
        readOnly={readOnly}
        onNavigateGoals={onNavigateGoals}
        onNavigateGoal={onNavigateGoal}
      />
    </div>
  )
}
